import { AppState } from '../../types/store';

export const getSelectedTierContentType = (state: AppState) =>
  state.subscriptionsSection.tierContentType;

export const getSelectedTierId = (state: AppState) =>
  state.subscriptionsSection.selectedTierId;
